import { render, staticRenderFns } from "./CustomerGroupActionDelete.vue?vue&type=template&id=9e8e5882&"
import script from "./CustomerGroupActionDelete.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports